import api from "@/api/api-v2-config";

export async function getSalesPersonListAxios() {    
    return await api.get("salespersons");
}
